'use client';

import React from 'react';
import { CollapsibleSection } from './collapsible-section';
import { SPACING } from '@/lib/design-tokens';

/**
 * Footnotes - Collapsible footnotes section for blog posts
 *
 * Wraps the footnotes section generated by remark-gfm with a collapsible interface.
 * Collapsed by default to reduce visual clutter while keeping references accessible.
 *
 * Features:
 * - Collapsed by default for cleaner reading experience
 * - Keyboard accessible (Enter, Space)
 * - Theme-aware styling
 * - Smooth expand/collapse animation
 * - WCAG AA compliant
 * - Uses CollapsibleSection component for consistency with other collapsible content
 */

interface FootnotesProps {
  children: React.ReactNode;
  className?: string;
}

export function Footnotes({ children, className }: FootnotesProps) {
  return (
    <CollapsibleSection
      id="footnotes"
      title="Footnotes"
      defaultExpanded={false}
      reducedSpacing={true}
      className={className}
    >
      <div className={`${SPACING.content} md:space-y-4 text-card-foreground`}>{children}</div>
    </CollapsibleSection>
  );
}
